import { create } from "zustand";
import { logout as logoutApi } from "./api";

type AuthTokenStoreState = {
  token: string | null;
  loggedInAsOtherUser: boolean;
};

type AuthTokenStoreActions = {
  setToken: (newToken: string) => void;
  removeToken: () => void;
  setLoggedInAsOtherUser: (val: boolean) => void;
  logout: (onError: () => void) => void;
};

const useAuthTokenStore = create<AuthTokenStoreState & AuthTokenStoreActions>(
  (set) => ({
    token: null,
    setToken: (newToken) => set({ token: newToken }),
    removeToken: () => set({ token: null }),
    loggedInAsOtherUser: false,
    setLoggedInAsOtherUser: (val: boolean) => set({ loggedInAsOtherUser: val }),
    logout: (onError: () => void) => {
      logoutApi()
        .then(() => {
          window.location.replace(
            process.env.REACT_APP_LOGIN_URL +
              "" +
              "?redirectUrl=" +
              window.location.protocol +
              "//" +
              window.location.host
          );
        })
        .catch(() => {
          onError();
        });
    },
  })
);

export default useAuthTokenStore;
